import type { ReviewEntry, RoundSummary } from '@geosport/shared';
import { isRecord, readJson, STORAGE_KEYS, writeJson } from './storage';

/**
 * Finished practice rounds (replays and random rounds) live only in this browser: they are never
 * ranked, so the API does not store them (DECISION: see round.ts on the API).
 */
export interface PracticeResult {
  summary: RoundSummary;
  review: ReviewEntry[];
  finishedAt: string;
}

interface PracticeStore {
  /** Keyed by the replayed date. */
  archive: Record<string, PracticeResult>;
  /** Newest first, capped. */
  random: PracticeResult[];
}

const MAX_RANDOM = 20;

const isStore = (v: unknown): v is PracticeStore =>
  isRecord(v) && isRecord(v['archive']) && Array.isArray(v['random']);

export function readPractice(): PracticeStore {
  return readJson(STORAGE_KEYS.practiceResults, isStore) ?? { archive: {}, random: [] };
}

export function savePractice(result: PracticeResult): void {
  const store = readPractice();
  if (result.summary.mode === 'archive') store.archive[result.summary.date] = result;
  else store.random = [result, ...store.random].slice(0, MAX_RANDOM);
  writeJson(STORAGE_KEYS.practiceResults, store);
}
